import React, { createContext, useContext, useCallback } from "react";
import toast, { Toaster } from "react-hot-toast";

const AlertContext = createContext();

export const AlertProvider = ({ children }) => {
  const triggerAlert = useCallback(
    (message, severity = "success", onClick = null) => {
      const baseStyle = {
        padding: "16px",
        fontWeight: 600,
        borderRadius: "16px",
        cursor: onClick ? "pointer" : "default",
      };

      const renderContent = (t) => (
        <div
          onClick={() => {
            if (onClick) {
              onClick();
              toast.dismiss(t.id);
            }
          }}
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          {message}
        </div>
      );

      switch (severity) {
        case "success":
          toast.success(onClick ? renderContent : message, {
            id: message,
            style: {
              ...baseStyle,
              background: "#edf7ed",
              color: "#1e4620",
              border: "1px solid #c8e6c9",
            },
            iconTheme: { primary: "#2e7d32", secondary: "#edf7ed" },
          });
          break;

        case "error":
        case "danger":
          toast.error(onClick ? renderContent : message, {
            id: message,
            icon: null,
            style: {
              ...baseStyle,
              background: "#fdeded",
              color: "#5f2120",
              border: "1px solid #f8bbd0",
            },
            iconTheme: { primary: "#d32f2f", secondary: "#fdeded" },
          });
          break;

        case "warning":
          toast(onClick ? renderContent : message, {
            id: message,
            icon: "⚠️",
            style: {
              ...baseStyle,
              background: "#fff4e5",
              color: "#663c00",
              border: "1px solid #ffe0b2",
            },
          });
          break;

        case "info":
          toast(onClick ? renderContent : message, {
            id: message,
            icon: "ℹ️",
            style: {
              ...baseStyle,
              background: "#e5f6fd",
              color: "#014361",
              border: "1px solid #b3e5fc",
            },
          });
          break;

        default:
          toast(onClick ? renderContent : message, {
            id: message,
            style: {
              ...baseStyle,
              background: "#ffffff",
              color: "#333333",
              border: "1px solid #e0e0e0",
            },
          });
      }
    },
    [],
  );

  return (
    <AlertContext.Provider value={{ triggerAlert }}>
      {children}
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
        }}
      />
    </AlertContext.Provider>
  );
};

export const useGlobalAlert = () => useContext(AlertContext);
